import React, { useEffect } from 'react';
import { classnames } from 'Utils/classnames';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import { toogleTjkTv } from 'Store/actions/horseRacing/getRaceInfos';
import { withMixpanel } from 'Utils/mixpanel';


const TvButton = ({ grayBg, mixpanel }) => {
  const dispatch = useDispatch();
  const showTjkTv = useSelector(state => state.horseRacing.allHippodromes.showTjkTv);
  const onButtonClick = () => {
    dispatch(toogleTjkTv(!showTjkTv));

  };
  useEffect(()=> {
    if (showTjkTv) mixpanel?.track('TJK Click TJK TV', { 'Channel Name': 'TJK TV', Source: grayBg ? 'Kupon Detay' : 'Bülten'  });
  }, [showTjkTv]);
  return (
    <div onClick={ onButtonClick } className={ classnames({ 'tjk-tv-button': true, 'gray-bg': grayBg }) }>
      <Icon iconName="svgPlayCircle" className="tjk-icon"/>
      <span>TJK TV</span>
      <Icon iconName="svgDownArrowWhite" className={ classnames({ 'arrow-down': true, 'arrow-up': showTjkTv }) }/>
    </div>
  );
};

TvButton.propTypes = {
  grayBg: PropTypes.bool,
  mixpanel: PropTypes.object
};
export default withMixpanel(TvButton);
